import { type MRT_ColumnDef, useMaterialReactTable } from 'material-react-table';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { CustomTable } from 'src/presentations/components/molecules/table/Table';
import { PercentageChargeDto } from 'src/generated/services/TFinancialApi';
import { beautifyEnum, formatMoney, formatNumber } from 'src/utils/utility';
import { formatDateString } from 'src/utils/date';

styled(Box)({
  '.MuiTableCell-head:first-of-type': {
    width: '40px',
  },
});
const useRateCardPercentageColumns = (): MRT_ColumnDef<PercentageChargeDto>[] => [
  {
    accessorKey: 'legType',
    header: 'Leg',
    enableEditing: false,
    accessorFn: (row: PercentageChargeDto) => <span className='capitalize'>{beautifyEnum(row?.legType)}</span>,
  },
  {
    accessorKey: 'chargeName',
    header: 'Charge Name / Category',
    enableEditing: false,
    accessorFn: (row: PercentageChargeDto) => (
      <span className='capitalize'>
        {beautifyEnum(row.chargeName)} / {beautifyEnum(row.chargeCategory)}
      </span>
    ),
  },
  {
    enableEditing: false,
    accessorKey: 'validityPeriod',
    header: 'Validity Period',
    accessorFn: (row) => `${formatDateString(row?.startDate)} - ${formatDateString(row?.endDate)}`,
  },
  {
    accessorKey: 'value',
    header: '% Value',
    enableEditing: false,
    accessorFn: (row: PercentageChargeDto) => <span className='capitalize'>{formatNumber(row?.value)} %</span>,
  },
  {
    enableEditing: false,
    accessorKey: 'minimumPrice',
    header: 'Minimum Price',
    accessorFn: (row) => formatMoney(row?.minimumPrice || 0, row?.currency || ''),
  },
];

export interface ITableRateCardPercentageProps {
  data: PercentageChargeDto[];
}

export const TableRateCardPercentage = ({ data }: ITableRateCardPercentageProps) => {
  const columns = useRateCardPercentageColumns();

  const table = useMaterialReactTable({
    data,
    enableRowNumbers: false,
    enableSorting: false,
    enablePinning: false,
    enableRowDragging: false,
    enableColumnActions: false,
    enablePagination: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enableEditing: false,
    editDisplayMode: 'table',
    muiTableHeadProps: {
      sx: {
        '& .MuiTableCell-head': {
          '&:first-of-type': {
            width: '100px',
            textAlign: 'center',
          },
        },
      },
    },
    columns,
  });
  return <CustomTable table={table} />;
};
